import type { AllRouteEndpoints } from "../routeTypes";
export const appGroupsAppGroupIdPlacementsCacheKeys: AllRouteEndpoints[] = [
  "/app_groups/:app_group_id/placements",
  "/app_groups/:app_group_id/placements/:id",
];

export const appGroupsAppGroupIdPlacements = "/app_groups/:app_group_id/placements";
